import $ from "jquery";

let productsBlock = $(".products-item ");
let productsHiddenElement = $(".products-item > .products-item__hidden");
let productsShownElement = $(".products-item > .products-item__shown");

productsShownElement.click(function () {
  if ($(this).parent().hasClass("products-item_open")) {
    productsHiddenElement.slideUp(300);
    productsBlock.removeClass("products-item_open");
    return false;
  } else {
    productsHiddenElement.slideUp(300);
    $(this).parent().siblings().removeClass("products-item_open");
    $(this).next().slideDown(300);
    $(this)
      .next()
      .slideDown(300, () => {
        $(this).parent().addClass("products-item_open");

        let anchor = document.querySelector("#" + $(this).data("id"));
        if (anchor) {
          window.lenis.scrollTo(anchor, { offset: -100, duration: 1 });
        }
      });
  }
});

export const tabsToggle = () => {
  window.addEventListener("click", (event) => {
    if (event.target.closest(".tabs-links__item")) {
      const container = event.target.closest(".tabs");
      const tabLink = event.target.closest(".tabs-links__item");
      const tabContent = container.querySelector(
        `[data-tab-content-id="${tabLink.dataset.tabLinkId}"]`
      );

      Array.from(container.querySelectorAll(".tabs-links__item")).find(
        (item) =>
          item !== tabLink && item.classList.remove("tabs-links__item--active")
      );
      Array.from(container.querySelectorAll(".tabs-content")).find(
        (item) =>
          item.dataset.tabContentId !== tabLink.dataset.tabLinkId &&
          item.classList.remove("tabs-content--visible")
      );

      tabLink.classList.add("tabs-links__item--active");
      tabContent.classList.add("tabs-content--visible");
    }
  });
};

tabsToggle();
// Hook for Safari
var ua = navigator.userAgent.toLowerCase();
if (ua.indexOf("safari") != -1) {
  if (!(ua.indexOf("chrome") > -1)) {
    document.getElementById("tabs").style.marginTop = "-10px";
    document.getElementById("tabs").classList.add("safari-title");
  }
}

function detectOS() {
  const userAgent = navigator.userAgent;
  const platform = navigator.platform;

  // iOS (iPhone, iPad)
  if (
    /iPad|iPhone|iPod/.test(userAgent) ||
    (platform === "MacIntel" && navigator.maxTouchPoints > 1)
  ) {
    return "mac";
  }

  // Android
  if (/Android/.test(userAgent)) {
    return "android";
  }

  // macOS (десктоп)
  if (platform.indexOf("Mac") !== -1 || userAgent.indexOf("Mac") !== -1) {
    return "mac";
  }

  // Windows
  if (platform.indexOf("Win") !== -1 || userAgent.indexOf("Win") !== -1) {
    return "windows";
  }

  // Linux
  if (userAgent.indexOf("Linux") !== -1) {
    return "linux";
  }

  return "other";
}

document.body.classList.add(`os-${detectOS()}`);
